import * as React from "react";

interface Props {
    level?: number,
    size?: string,
    required?: boolean,
    value?: any,
    onChange?: any,
    name?: string
}

interface State {
    value?: any
}

export default class FormCheckBox extends React.Component<Props, State> {
    name: string;

    constructor(props) {
        super(props);
        this.name = this.getName();

        let tmp_value = false;
        if(this.props.value)
            tmp_value = this.props.value

        this.state = {
            value: tmp_value
        }
    }

    getName() {
        if(this.props.name)
            return this.props.name;

        let rnd = Math.floor(Math.random() * 999999) + 1;

        return "form-check-" + rnd;
    }

    onChange(e) {
        if(this.props.onChange) 
            this.props.onChange(this.name, !this.state.value);

        this.setState({
            value: !this.state.value
        });
    }

    render() {
        let level = 1, c_level = "custom-checkbox";

        if(this.props.level) {
            level = this.props.level;
            if(level > 3)
                level = 3;
        } else {
            level = 1;
        }

        if(level == 2)
            c_level = "custom-checkbox second-level-checkbox";
        else if(level == 2)
            c_level = "custom-checkbox third-level-checkbox";

        return (
            <div className={c_level}>
                <label style={{fontSize: this.props.size}}>
                    {this.props.children} {this.props.required && <span>*</span>}
                    <input type="checkbox" name={this.name} checked={this.state.value} onChange={(event) => this.onChange(event)} />
                    <span className={"checkmark"}></span>
                </label>
            </div>
    )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/FormCheckBox.tsx